<template>
  <div class="py-4 container-fluid">

    <div class="row mb-4">
      <div class="col-lg-12 position-relative z-index-2">
        <div class="row">
          <div class="col-sm-7">
            <h1 class="mainTitle">Dashboard</h1>
            <!-- <span class="mainDescription" v-if="access_token">Hello, {{ userName }} </span> -->
            <span class="mainDescription">Hello, Admin </span>
            <!-- <div class="page-header min-height-300 border-radius-xl mt-4" style="
        background-image: url('https://images.unsplash.com/photo-1531512073830-ba890ca4eba2?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80');
      ">
              <span class="mask bg-gradient-warning opacity-6"></span>
            </div> -->
            <!-- <h1 v-if="access_token">Hello, {{ userName }}</h1> -->
            <!-- <h3 v-if="!access_token">not logged in</h3> -->
          </div>

        </div>
      </div>
    </div>

    <div class="row">

    </div>
  </div>
</template>
<script>
import logoXD from "@/assets/img/small-logos/logo-xd.svg";
import logoAtlassian from "@/assets/img/small-logos/logo-atlassian.svg";
import logoSlack from "@/assets/img/small-logos/logo-slack.svg";
import logoSpotify from "@/assets/img/small-logos/logo-spotify.svg";
import logoJira from "@/assets/img/small-logos/logo-jira.svg";
import logoInvision from "@/assets/img/small-logos/logo-invision.svg";
import team1 from "@/assets/img/team-1.jpg";
import team2 from "@/assets/img/team-2.jpg";
import team3 from "@/assets/img/team-3.jpg";
import team4 from "@/assets/img/team-4.jpg";
export default {
  name: "dashboard-default",
  data() {
    return {
      userName: "",
      access_token: null,
      appUrl: "",
      logoXD,
      team1,
      team2,
      team3,
      team4,
      logoAtlassian,
      logoSlack,
      logoSpotify,
      logoJira,
      logoInvision,
    };
  },

  // async beforeCreate() {
  //   this.access_token = localStorage.getItem("token");
  //   this.userName = store.user ? store.user.name : 'User'; // Fallback to "User" if not found
  // }
};
</script>
